import { inject } from '@angular/core'
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router'
import { TeamOverviewService } from './service'

export const teamResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot) => {
  const ts = inject(TeamOverviewService)
  ts.teamId.set(route.paramMap.get('teamId') ?? '')
  // Seed only; never clobber a season the user has already picked. The season
  // is shared app-wide and persisted, so it survives navigation and reloads.
  ts.seedSeason()
  // Once the team's seasons are known, a team with nothing in this season opens on its newest one.
  ts.requestLanding()
  return true
}
